import { MembershipRoles } from '../data-models/membership-roles.model';

/**
 * Helper functions for role management
 */
export class RoleHelper {
  static hasRole(combinedRole: number, role: MembershipRoles): boolean {
    return (combinedRole & role) === role;
  }

  static getRoleNames(combinedRole: number): string[] {
    const roles: string[] = [];
    if (this.hasRole(combinedRole, MembershipRoles.Owner)) {
      roles.push('Owner');
    }
    if (this.hasRole(combinedRole, MembershipRoles.ChiefSupervisor)) {
      roles.push('Chief Supervisor');
    }
    if (this.hasRole(combinedRole, MembershipRoles.PilotInCharge)) {
      roles.push('Pilot in Command');
    }
    if (this.hasRole(combinedRole, MembershipRoles.Pilot)) {
      roles.push('Pilot');
    }
    return roles;
  }

  static getRoleAbbreviation(combinedRole: number): string {
    const abbrevs: string[] = [];
    if (this.hasRole(combinedRole, MembershipRoles.Owner)) {
      abbrevs.push('Owner');
    }
    if (this.hasRole(combinedRole, MembershipRoles.ChiefSupervisor)) {
      abbrevs.push('CS');
    }
    if (this.hasRole(combinedRole, MembershipRoles.PilotInCharge)) {
      abbrevs.push('PIC');
    }
    if (this.hasRole(combinedRole, MembershipRoles.Pilot)) {
      abbrevs.push('Pilot');
    }
    return abbrevs.join(', ');
  }

  static getCertificationStatusClass(status: string): string {
    switch (status) {
      case 'active':
      case 'valid':
        return 'text-success';
      case 'expiring-soon':
        return 'text-warning';
      case 'expired':
      case 'missing':
        return 'text-danger';
      default:
        return 'text-secondary';
    }
  }

  static getCertificationStatusIcon(status: string): string {
    switch (status) {
      case 'active':
      case 'valid':
        return '🟢';
      case 'expiring-soon':
        return '🟡';
      case 'expired':
      case 'missing':
        return '❌';
      default:
        return '⚪';
    }
  }
}
